import type { Container } from 'pixi.js';
import type { LayoutAnimationData, LayoutRawDataWithAnimation } from './types';
import type { AllProps } from '../../propsMixin/props';
import { adaptTarget } from './adaptTarget';

export function skipToTheEndOfAnimation(layoutInstance: unknown, animationName: string): void {
  const rawData = (layoutInstance as { constructor: { raw: LayoutRawDataWithAnimation } }).constructor.raw;

  const animationData: LayoutAnimationData | null =
    rawData?.animations?.find((data) => data.name === animationName) ?? null;

  if (!animationData) {
    console.warn(`Cannot find animation ${animationName} in layout`);
    return;
  }

  const propsToApply: Record<string, AllProps> = {};

  animationData.blocks
    .slice()
    .sort((a, b) => a.startAt - b.startAt)
    .forEach((block) => {
      propsToApply[block.sourceName] = { ...(propsToApply[block.sourceName] ?? {}), ...adaptTarget(block.target) };
    });

  const layout = layoutInstance as Record<string, Container>;

  Object.entries(propsToApply).forEach(([key, props]) => {
    if (!layout[key] || layout[key].destroyed) return;
    layout[key].props(props);
  });
}
